export default __webpack_public_path__ + "static/media/Gift.11ab4891.svg";